<img
    [ngSrc]="logoUrl()"
    [width]="size() === IrisLogoSize.SMALL ? 279 : 557"
    [height]="size() === IrisLogoSize.SMALL ? 256 : 512"
    alt="Iris Logo"
    [classList]="'iris-logo ' + classList() + (spinning() ? ' spinning' : '')"
    [style.height.px]="numericHeight()"
/>
